;
import * as windows1250 from 'windows-1250/windows-1250';
var Cookies = require('js-cookie');

(function ($) {
	"use strict";
	window.AndroidAppInterface = function (options) {
		this._init(options);
	};

	$.extend(AndroidAppInterface.prototype, {
		$options: {
			loadingPrintData: false,
			isApp: false,
		},

		//=====================================================================
		
		isApp: function() {
			return this.$options.isApp;
		},
		
		//=====================================================================
		
		initAndroidApp: function() {
			if (typeof window.flutter_inappwebview != "undefined") {
				this.$options.isApp = true;
				if (window.$wdEventCommon) {
					window.$wdEventCommon.setSheriffDeviceInfo("androidApp", true);
				}
				this.checkVersion();
				window.flutter_inappwebview.callHandler('setUserId', [getSheriffId()]);
				
				$('button.printTicketButton').show();
			}
			
		},
		
		checkVersion: function() {
			window.flutter_inappwebview.callHandler('getVersion')
				.then(function(version) {
					$('#mobile-detection-field').html("Mobilní aplikace, verze: " + version);
				});
		},

		printTicket: function (url) {

			if (typeof window.flutter_inappwebview != "undefined") {
				var printerMac = Cookies.get('btPrinterMacAddress');
				this.getDataAndPrint(printerMac, url);
			} else {
				console.warn("Android is not defined");
			}
		},

		getDataAndPrint: function (mac, url) {
			var app = this;

			if (!app.$options.loadingPrintData) {
				app.$options.loadingPrintData = true;
				$.ajax({
					type: "post",
					url: url,
					dataType: 'json',
					contentType: "application/json",
					data: {},
					success: function (response) {
						if (('data' in response) && response.data) {
							var charcodes = "<p>";
							for (var i = 0; i < 8; i++) {
								charcodes += response.data.charCodeAt(i)+" ";
							}
							charcodes += "</p>";
							bootbox.confirm({
								message: "<img src='data:image/png;base64,"+response.data+"' alt='preview' width='200px'>" + charcodes,
								callback: function (result) {
									if (result) {
										var args = [mac, response.data];
										window.flutter_inappwebview.callHandler('printImage', ...args)
											.then(function(result) {
												console.log(result)
											});
									}
								}
							});
						} else if (('error' in response) && response.error) {
							bootbox.alert(response.error);
						}

						app.$options.loadingPrintData = false;
					},
					error: function (e) {
						console.log(e);
						app.$options.loadingPrintData = false;
					},
				});
			}

		},

		printCallback: function (data) {
			if (typeof data === 'object') {
				if (('result' in data) && data.result) {
					if (('address' in data) && data.address) {
						Cookies.set('btPrinterMacAddress', data.address);
					}
				}
			}
		},

		//=====================================================================

		/**
		 * HANDLE BUTTONS
		 */
		handleButtons: function() {
			var app = this,
				$document = $(document);

			console.log('androidAppInterface::init');
			window.addEventListener("flutterInAppWebViewPlatformReady", function(event) {
				console.log('androidAppInterface::flutterInAppWebViewPlatformReady');
				app.initAndroidApp();
			});
			
			$document.on('click touchend', 'button.printTicketButton', function (e) {
				e.preventDefault();
				app.printTicket($(this).data('route'));
			});
			
			//TODO smazat
			$document.on('click touchend', '#dashboardPrintTicketButton', function (e) {
				e.preventDefault();
				app.printTicket($(this).data('route'));
			});
		},

		_init: function (options) {
			this.$options = $.extend({}, this.$options, options || {});
			this.handleButtons();
			
		},
	});

})(jQuery);

